"use strict";

var _defineProperty = require("/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/defineProperty.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactMarkdown = _interopRequireDefault(require("react-markdown"));
var _classnames = _interopRequireDefault(require("classnames"));
var _remarkBreaks = _interopRequireDefault(require("remark-breaks"));
var _heading = _interopRequireWildcard(require("../heading"));
var _paragraph = _interopRequireDefault(require("../paragraph"));
var _indexModule = _interopRequireDefault(require("./index.module.scss"));
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
const headingSizeLevelMapping = {
  1: _heading.HeadingSize.large,
  2: _heading.HeadingSize.medium,
  3: _heading.HeadingSize.small
};
const Markdown = _ref => {
  let {
    content,
    renderers,
    wrapperClass,
    allowDangerousHtml
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_reactMarkdown.default, {
    allowDangerousHtml: allowDangerousHtml,
    source: content,
    plugins: [_remarkBreaks.default],
    renderers: _objectSpread({
      /* eslint-disable react/display-name */
      root: _ref2 => {
        let {
          children
        } = _ref2;
        return /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)(_indexModule.default.Markdown, wrapperClass)
        }, children);
      },
      paragraph: _ref3 => {
        let {
          children
        } = _ref3;
        return /*#__PURE__*/_react.default.createElement(_paragraph.default, null, children);
      },
      heading: _ref4 => {
        let {
          level,
          children
        } = _ref4;
        return /*#__PURE__*/_react.default.createElement(_heading.default, {
          type: headingSizeLevelMapping[level] || _heading.HeadingSize.extrasmall
        }, children);
      },
      tableCell: _ref5 => {
        let {
          isHeader,
          children
        } = _ref5;
        return isHeader ? /*#__PURE__*/_react.default.createElement("th", null, /*#__PURE__*/_react.default.createElement(_heading.default, {
          type: _heading.HeadingSize.extrasmall
        }, children)) : /*#__PURE__*/_react.default.createElement("td", null, children);
      }
    }, renderers)
  });
};
var _default = exports.default = Markdown;